const mediaItems = [
  {
    id: 1,
    title: '最新国产剧情片精选合集',
    duration: '128分钟',
    category: '剧情',
    tag: '热播',
    views: '12.8万',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20film%20poster%20style%20with%20elegant%20traditional%20costumes%20in%20warm%20amber%20cinematic%20lighting%2C%20dramatic%20composition%20with%20soft%20shadows%20and%20golden%20haze%2C%20film%20grain%20texture%2C%20movie%20poster%20aesthetic%20with%20rich%20crimson%20and%20gold%20accents%2C%20high%20detail%20artistic%20rendering%2C%20vintage%20Chinese%20cinema%20vibe&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '都市情感剧集连播 — 温情治愈系列',
    duration: '96分钟',
    category: '爱情',
    tag: '推荐',
    views: '9.6万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20romance%20film%20scene%20with%20couple%20under%20warm%20street%20lights%20at%20dusk%20in%20a%20bustling%20city%2C%20cinematic%20widescreen%20composition%20with%20soft%20golden%20hour%20lighting%2C%20shallow%20depth%20of%20field%2C%20film%20grain%20texture%2C%20movie%20still%20aesthetic%2C%20nostalgic%20warm%20atmosphere%2C%20romantic%20mood&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '动作冒险大片 — 高燃对决场面',
    duration: '142分钟',
    category: '动作',
    tag: '新片',
    views: '18.3万',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20action%20thriller%20film%20scene%20on%20urban%20rooftop%20at%20sunset%20with%20dramatic%20orange%20and%20crimson%20sky%2C%20wide%20cinematic%20shot%20with%20motion%20blur%2C%20high%20contrast%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20movie%20still%20aesthetic%2C%20intense%20atmospheric%20mood%2C%20professional%20cinematography&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="section-scroll py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">精选推荐</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">精选推荐</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            每日精选热门91精品视频在线播放资源，为你呈现最值得观看的国产影片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-gray-50 border border-gray-100 hover:border-red-200 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-gray-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    const p = t.parentElement;
                    if (p) {
                      p.classList.add('flex', 'items-center', 'justify-center', 'bg-gray-100');
                      p.innerHTML = '<div class="text-gray-400 text-sm"><i class="ri-movie-2-line text-2xl block mb-1"></i>影片预览</div>';
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-red-600 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded-md bg-black/70 text-white text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-red-50 text-red-600 text-xs font-medium">
                    {item.category}
                  </span>
                  <span className="text-gray-400 text-xs flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>{item.views}次观看
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-gray-900 group-hover:text-red-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}